import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var NetworkSvg = function NetworkSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.249a8.33 8.33 0 0 0-5.843 2.384 8.08 8.08 0 0 0-2.42 5.756c0 2.158.87 4.229 2.42 5.755a8.32 8.32 0 0 0 5.135 2.354v2.356H3.5v1.395h17v-1.395h-7.792v-2.356a8.32 8.32 0 0 0 5.135-2.354 8.08 8.08 0 0 0 2.42-5.755c0-2.16-.87-4.23-2.42-5.756A8.33 8.33 0 0 0 12 2.249m-4.842 3.37a6.9 6.9 0 0 1 2.84-1.68L8.175 9.69H5.189A6.7 6.7 0 0 1 7.16 5.62m2.5 4.072 1.914-6.033a7 7 0 0 1 .632-.01l2.11 6.043zm4.655 1.395H9.658l1.914 6.034a7 7 0 0 0 .632.01zm-.531 5.814 2.03-5.814h2.999a6.7 6.7 0 0 1-1.97 4.071 6.9 6.9 0 0 1-3.06 1.743m2.03-7.21-2.03-5.813a6.9 6.9 0 0 1 3.06 1.743 6.7 6.7 0 0 1 1.969 4.07zM5.188 11.087h2.985l1.825 5.752a6.9 6.9 0 0 1-2.84-1.68 6.7 6.7 0 0 1-1.97-4.072",
    clipRule: "evenodd"
  }));
};
export var Network = function Network(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: NetworkSvg
  }));
};